module.exports = __webpack_public_path__ + "static/media/sparkle-playground.d58e8b96.mp3";